import React from 'react';
import Layout from '../components/Layout';
import { CampanaCobranza } from '../components/cobranzas/campana/CampanaCobranza';

const Campana = () => {
    return (
        <Layout>
            <div className="w-full min-h-screen bg-gray-50">
                <CampanaCobranza />
            </div>
        </Layout>
    );
};

export default Campana;
